import { render } from "./SendThanksIcon.vue?vue&type=template&id=f28abe50"
import script from "./SendThanksIcon.vue?vue&type=script&lang=js"
export * from "./SendThanksIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__